"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _useIntersectionObserver = _interopRequireDefault(require("@livongo/utilities/hooks/useIntersectionObserver"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _ImageModule = _interopRequireDefault(require("./Image.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameImage", "testAttrRoot", "testAttrImage", "alt", "src", "cloudinaryImageId", "width", "height", "quality", "format", "showLoader", "lazyLoad", "lazyLoadOffsetVertical", "onLoad", "onError"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createCloudinaryUrl(_ref) {
  let {
    cloudinaryImageId,
    width,
    height,
    quality,
    format
  } = _ref;
  return "https://assets.livongo.com/image/upload/dpr_".concat(_environment.default.isHighDensityDisplay() ? 2 : 1, ",w_").concat(width, ",h_").concat(height, ",q_").concat(quality, ",f_").concat(format, "/").concat(cloudinaryImageId);
}
const Image = _ref2 => {
  let {
      classNameRoot,
      classNameImage,
      testAttrRoot,
      testAttrImage,
      alt,
      src,
      cloudinaryImageId,
      width,
      height,
      quality,
      format,
      showLoader,
      lazyLoad,
      lazyLoadOffsetVertical,
      onLoad,
      onError
    } = _ref2,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  const [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  const [imgSrc, setImgSrc] = (0, _react.useState)(cloudinaryImageId || lazyLoad ? null : src);
  const ioTargetRef = (0, _useIntersectionObserver.default)(_objectSpread({
    enabled: lazyLoad,
    rootMargin: "".concat(lazyLoadOffsetVertical, "px 0px"),
    disconnectWhenVisible: true
  }, lazyLoad && {
    onChange(_ref3) {
      let {
        isIntersecting
      } = _ref3;
      if (isIntersecting) {
        setImgSrc(src || createCloudinaryUrl({
          cloudinaryImageId,
          width,
          height,
          quality,
          format
        }));
      }
    }
  }));
  const onLoaded = evt => {
    setIsLoaded(true);
    if (onLoad) {
      onLoad(evt);
    }
  };
  const onErrored = evt => {
    setIsLoaded(true);
    if (onError) {
      onError(evt);
    }
  };
  (0, _react.useEffect)(() => {
    if (cloudinaryImageId) {
      // cloudinary image provided, create the source path
      if (!width || !height) {
        throw new Error('The `width` and `height` props are required when using a Cloudinary image.');
      }

      // the source is set after component is mounted in the case of Cloudinary images otherwise there are mis-matching
      // DPR attributes in the url since node will always set the DPR to 1 and high density displays will have it set to 2+.
      if (!lazyLoad) {
        setImgSrc(createCloudinaryUrl({
          cloudinaryImageId,
          width,
          height,
          quality,
          format
        }));
      }
    } else if (!src) {
      throw new Error('The `src` prop is required when not using a Cloudinary image.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ioTargetRef,
    className: (0, _cnbuilder.cnb)(classNameRoot, _ImageModule.default.root),
    "data-test": testAttrRoot,
    style: {
      maxWidth: width,
      maxHeight: height
    },
    children: [showLoader && !isLoaded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      classNameRoot: _ImageModule.default.loader,
      testAttrRoot: "loader",
      inline: width < 80 || height < 80,
      size: width < 80 || height < 80 ? 'small' : 'large'
    }), imgSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
      className: (0, _cnbuilder.cnb)(_ImageModule.default.image, classNameImage),
      "data-test": testAttrImage,
      alt: alt,
      src: imgSrc,
      width: width,
      height: height,
      onLoad: onLoaded,
      onError: onErrored
    }, rest))]
  });
};
Image.defaultProps = {
  testAttrRoot: 'image-root',
  testAttrImage: 'image-img',
  showLoader: true,
  lazyLoadOffsetVertical: 100,
  quality: 'auto',
  format: 'auto'
};
var _default = exports.default = Image;